const ManagedStateInfo = () => {
  return <span>State managed by Spacelift</span>;
};

export default ManagedStateInfo;
